/* eslint-disable react/display-name */
import React, { forwardRef, memo, useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from "./modal";
import Header from "./header";
import Body from "./body";
import Footer from "./footer";
const ModalSample = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  action = {},
  bodyStyle,
  children,
  footer,
  footerStyle,
  headerStyle,
  style,
  title,
  ...props
}, reference) => {
  const ref = useRef(null);
  useImperativeHandle(reference, () => {
    const currentRef = ref.current || {};
    currentRef.element = ref.current;
    const _instance = {
      ...action
    }; // methods
    _instance.__proto__ = {}; // hidden methods
    currentRef.instance = _instance;
    return currentRef;
  });
  return /*#__PURE__*/React.createElement(Modal, {
    ref: ref,
    style: style,
    ...props
  }, /*#__PURE__*/React.createElement(Header, {
    style: headerStyle
  }, title), /*#__PURE__*/React.createElement(Body, {
    style: bodyStyle
  }, children), footer && /*#__PURE__*/React.createElement(Footer, {
    style: footerStyle
  }, footer));
}));
ModalSample.defaultProps = {
  title: ''
};
ModalSample.propTypes = {
  /** Style inline of the body component. */
  bodyStyle: PropTypes.object,
  /** The content of the body component. */
  children: PropTypes.node,
  /** The content of the footer component. */
  footer: PropTypes.node,
  /** Style inline of the footer component. */
  footerStyle: PropTypes.object,
  /** Style inline of the header component. */
  headerStyle: PropTypes.object,
  /** Style inline of component. */
  style: PropTypes.object,
  /** The content of the header component. */
  title: PropTypes.node,
  /** Any props else. */
  props: PropTypes.any
};
export default ModalSample;